import { Box, Link as ChakraLink, Heading, Text, VStack } from '@chakra-ui/react';
import React from 'react';
import { FiMessageCircle } from 'react-icons/fi';
import type { LearnMoreSearchResponse } from '../hooks/useLearnMoreSearch';

interface SearchResultsProps {
  response: LearnMoreSearchResponse;
}

const SearchResults = ({ response }: SearchResultsProps): React.JSX.Element => {
  return (
    <Box
      bg="gray.50"
      _dark={{ bg: 'gray.800' }}
      borderRadius="xl"
      p={6}
      mt={8}
      maxW="800px"
      mx="auto"
    >
      <VStack align="stretch" gap={4}>
        <Box display="flex" alignItems="flex-start" gap={3}>
          <Box p={2} borderRadius="full" bg="blue.100" _dark={{ bg: 'blue.900' }} color="blue.600">
            <FiMessageCircle size={20} />
          </Box>
          <Text fontSize="md" color="gray.700" _dark={{ color: 'gray.200' }} lineHeight="tall">
            {response.answer}
          </Text>
        </Box>

        {response.suggestedArticles.length > 0 && (
          <Box mt={4}>
            <Heading as="h4" size="sm" mb={3} color="gray.600" _dark={{ color: 'gray.400' }}>
              Suggested Articles
            </Heading>
            <VStack align="stretch" gap={2}>
              {response.suggestedArticles.map((article) => (
                <ChakraLink
                  key={article.slug}
                  href={`/learn-more/${article.slug}`}
                  display="flex"
                  alignItems="center"
                  gap={2}
                  p={3}
                  borderRadius="md"
                  bg="white"
                  _dark={{ bg: 'gray.700' }}
                  _hover={{ bg: 'blue.50', _dark: { bg: 'gray.600' } }}
                  transition="background 0.2s"
                >
                  <Text fontWeight="medium" color="blue.600" _dark={{ color: 'blue.400' }}>
                    {article.title}
                  </Text>
                  {article.relevance && (
                    <Text fontSize="sm" color="gray.500">
                      {article.relevance}
                    </Text>
                  )}
                </ChakraLink>
              ))}
            </VStack>
          </Box>
        )}
      </VStack>
    </Box>
  );
};

export default SearchResults;
